import { StickerGrid } from '@/components/stickers/sticker-grid';
import SymbolBlock from '@/components/symbol/symbol-block';
import { useSymbolContext } from '@/components/symbol/symbol-context';
import useUserStickers from '@/hooks/stickers/use-user-stickers';
import type { UserSticker } from '@/models/user/custom-sticker';

export default function CustomStickerBlocks() {
  const { sendSticker } = useSymbolContext();
  const { stickers } = useUserStickers();

  const handleStickerClick = (sticker: UserSticker) => {
    sendSticker(sticker.StickerUrl);
  };

  return (
    <SymbolBlock
      key='custom-sticker'
      slug='custom-sticker'>
      <StickerGrid
        stickers={stickers}
        onClick={handleStickerClick}
        className='xs:grid-cols-5 mobile:sm:grid-cols-6 mobile:md:grid-cols-8'
      />
    </SymbolBlock>
  );
}
